
import { Component, Prop, Vue } from "vue-property-decorator";
import FinderVue from "@/finder/Finder.vue";

import  ButtonVue from "@/lib/Button.vue";
import { IWykrojnikParams } from "./IWykrojnikParams";
import { WykrojnikParams } from "./WykrojnikParams";
import { Next, Route } from 'vue-router';
import { ITree } from "@/tree/ITree";
import { WykrojnikParamsGen } from "./WykrojnikParamsGen"
import  WykrojnikTitleVue  from "../WykrojnikTitleVue.vue"
import { WykrojnikParamsSvc } from "./WykrojnikParamsSvc"

import Bus from "@/lib/Bus"; import { TreeSvc } from "@/tree/TreeSvc";
import { IWykrojnikRow } from "../IWykrojnikRow";
import { LblSvc } from "@/lbl/LblSvc";
import { WykrojnikSvc } from "../WykrojnikSvc";
import { Dims } from "../../../server/src/tree/Dims";

 const bus: Bus = new Bus().getBus();

 @Component({
        async beforeRouteEnter(to: Route, from: Route, next: Next<WykrojnikParamsVue>) {
            next((vm: WykrojnikParamsVue) => {
              vm.tree_id = to.params.id
            });
        },

      components: { FinderVue, ButtonVue, WykrojnikTitleVue }
})
export default class WykrojnikParamsVue extends Vue {
    
    ksztalty:any[]= [{id:'P',opis:'Prostokąt'},{id:'K',opis:'Okrąg'}, {id:'O',opis:'Owal'},{id:'S',opis:'Specjalny'},{id:'E',opis:'Elipsa'}, {id:'N',opis:'Nieregularny'}]
    wp:IWykrojnikParams = WykrojnikParams.get_test_params();
    wp_gen:IWykrojnikParams = WykrojnikParams.get_test_params();
    tree_id:any;    

    @Prop(Object) tree:ITree|undefined;
    _tree:ITree|undefined;
    key:number=0;

    created() {
      //bus.register('tree_modified',this.tree_modified)
    }

    async mounted() {
      if (!this.tree_id) return;
      console.log(this.tree_id)

      this._tree= await new TreeSvc().find_by_id( this.tree_id ); 
      await this.get();

      await this.tree_chg();

      this.key++
      
    }

    beforeDestroy() {
      bus.remove('tree_modified',this.tree_modified)
    }

    async tree_modified(e:any) {
      this._tree = e.detail;
      await this.tree_chg()
    }

    async tree_chg() {
      if (!this._tree) return;
      const msgs = Dims.set_dims_to_wp(undefined, this.tree, undefined, this.wp)
      const wp = await WykrojnikParamsSvc.fill_restrictions_from_tree(this.wp, this._tree);

      

      if (wp) this.wp=wp;
      console.log("before chg",this.wp)
      this.chg()
      console.log("after chg",this.wp)
    }

    async chg_x() {
      this.wp.min.x = this.wp.x;
      this.wp.max.x = this.wp.x;
      await this.chg()      
    }

    async chg_y() {
      this.wp.min.y = this.wp.y;
      this.wp.max.y = this.wp.y;
      await this.chg()      
    }

    async set_xy(x:number, y:number) {
        
        this.wp.x=x;
        this.wp.y=y;

        this.wp.min.x=Math.round(this.wp.x)-1
        this.wp.max.x=Math.round(this.wp.x)+1

        this.wp.min.y=Math.round(this.wp.y)-1
        this.wp.max.y=Math.round(this.wp.y)+1

        if (this._tree && this._tree._id) {
          
          

          new WykrojnikSvc().del_selected_wykrojnik_for_tree(this._tree._id)
          
          this._tree= await new TreeSvc().update( this._tree ); 
          

          const lbl_svc = new LblSvc()

          const lbl = await lbl_svc.find_by_id(this._tree?.lbl_id)
          const msgs = Dims.set_dims_to_tree(lbl, this._tree, undefined, this.wp)   
          if (lbl && lbl._id)  lbl_svc.update(lbl)
    }
    }

    async exchange_xy() {

        await this.set_xy(this.wp.y, this.wp.x)
        alert("Zamieniono wymiary x i y")
        await this.chg()
    }

    async chg_nr_wykrojnika() {
      
      if (this.wp.nr_wykrojnika) {
        const ww = await bus.call("/api/wykrojniki/get_wykrojniki_ist_by_wykrojnik_nr",{nr_wykrojnika: this.wp.nr_wykrojnika}) 
        console.log(ww.list)
        if (ww && ww.list && ww.list.length==1) {
          const w:IWykrojnikRow = ww.list[0]
          this.wp.ksztalt = w.ksztalt
          await this.set_xy(w.x, w.y)

          alert("przejęto wymiary z wykrojnika")
          await this.chg()
          
        } 
      }
      else {
          await this.chg() 
      }
    }




    async chg_tryb() {
      if (!this.wp.tryb_eksperta) this.wp.tryb_eksperta=1;
      else this.wp.tryb_eksperta=0;
      await this.chg()      
    }

    async chg_ignore_podklad() {
      if (!this.wp.ignore_podklad) this.wp.ignore_podklad=1;
      else this.wp.ignore_podklad=0;
      await this.chg()      
    }

    async chg() {
      console.log("chg",this.wp.x, this.wp.y )
      this.wp_gen = await WykrojnikParamsGen.calc(this.wp.x, this.wp.y, this.wp.ksztalt, this.wp.szerokosci, this.wp.zeby, this.wp.banda_min, this.wp.is_folia, this.wp.podklad, this.wp.grubosc_podkladu)
      console.log(this.wp_gen)
      await this.update();
      await bus.fire("wykrojniki_params_changed", this.wp)
      this.key++;
    }

    async update() {
      if (!this.wp) return;
      if (!this.tree_id) return;
      this.wp._id = this.tree_id;

      const r=await bus.call("/api/wp/update", this.wp);
      if (r) {
        (<any>this.wp).version=r.version;
      }
    }

    async get() {
      if (!this.tree_id) return;
      console.log('this.tree_id', this.tree_id)
      const r=await bus.call("/api/wp/find_by_tree_id", {_id: this.tree_id}).catch( (err:any) => { console.log(err); });
      if (r && r._id) {
        console.log(r)
        this.wp = r;
      } else {
        await this.chg()
      }
    }


   

}

